module.exports = __webpack_public_path__ + "img/mediumRain.bac36e22.svg";